import apiClient from '@/api/apiClient';
import type { User, UserCreate, UserUpdate } from '@/types/user';

export default {
  getUsers(): Promise<User[]> {
    return apiClient.get('/account-admin/users');
  },
  createUser(data: UserCreate): Promise<User> {
    return apiClient.post('/account-admin/users', data);
  },
  updateUser(userId: string, data: UserUpdate): Promise<User> {
    return apiClient.put(`/account-admin/users/${userId}`, data);
  },
  deleteUser(userId: string): Promise<void> {
    return apiClient.delete(`/account-admin/users/${userId}`);
  },
};
